import { MONEY_CASH, MONEY_CARD } from "constants/Types";

export const NOTES = [
  { id: 1, type: 'Call_before_delivery', label: 'Call before delivery' },
  { id: 2, type: 'Call_to_schedule', label: 'Call to schedule' },
  { id: 3, type: 'Leave_with_concierge', label: 'Leave with concierge' },
  { id: 4, type: 'Leave_at_the_door', label: 'Leave at the door' },
  {
    id: 5,
    type: 'Always_someone_available',
    label: 'Someone’s always available',
  },
  { id: 6, type: 'Meet_at_the_car', label: 'Meet at the car' },
  { id: 7, type: 'Leave_with_neighbor', label: 'Leave with neighbor' },
  { id: 8, type: 'Other', label: 'Other: please specify' },
];

export const OTHER_NOTES = 8;

export const customers = [
  'Asia',
  'Jamila',
  'Zeinab',
  'Neam',
  'Ayham',
  'James',
  'Samah',
  'Dalia',
];

export const types = ['B2B', 'B2C', 'Customer'];

export const objectTypes = {
  location: {
    label: 'LOCATION',
    type: 'locationTypes',
  },
  package: {
    label: 'PACKAGE',
    type: 'packageTypes',
  },
  industries: {
    label: 'INDUSTRY',
    type: 'industryTypes',
  },
};

export const zones = [
  'Beirut',
  'Bent Jbayl',
  'Nabatiyeh',
  'Beirut-three',
  'Zahleh',
  'Aley',
  'Baabda',
  'Chouf',
  'Jbayl',
  'Kesrouan',
  'Matn',
  'Akkar',
  'Batroun',
  'Bcharreh',
  'Koura',
  'Miniyeh-Danniyeh',
  'Tripoli',
  'Zgharta',
  'Jezzine',
  'Saida',
  'Sour',
  'Zahrany',
  'Beirut-two',
  'Beirut-one',
  'Baalbek-Hermel',
  'WestBekaa-Rachaya',
];

export const orders = [];

export const CURRENCY_USD = 1;

export const SHOPIFY_APP_ID = 1;
export const ECOMZ_APP_ID = 3;
export const WOOCOMMERCE_APP_ID = 4;
export const MARKETPLACE_APP_ID = 6;
export const CUSTOM_APP_ID = 5;

export const drivers = [];

export const contacts = [];

export const recipients = [];

export const locations = [];

export const location = {};

export const notifications = [];

export const tasks = [];

export const SETTINGS_CHECK_IN_OUT_CONFIRMATION = 1;
export const SETTINGS_SERVICE_REQUEST_EMAIL = 2;

export const SETTINGS = [
  { id: 1, name: 'Check in/out confirmation' },
  { id: 2, name: 'Send service request to email' },
];

export const SERVICE_PICKUP_OR_DELIVER_ITEM = 8;
export const SERVICE_BUY_SOMETHING = 9;
export const SERVICE_RUN_BUSINESS = 10;
export const SERVICE_DONATE = 11;

export const SERVICES = [
  { id: 8, name: 'I want to pickup or deliver an item' },
  { id: 9, name: 'I want to buy something' },
  { id: 10, name: 'Run a business' },
  { id: 11, name: 'I want to check initiatives and donate' },
];

export const ROLE_ADMIN = 1;
export const ROLE_OPERATOR = 4;
export const ROLE_ACCOUNTANT = 5;
export const ROLE_TRACKER = 6;
export const ROLE_EXTERNAL_VIEWER = 7;
export const ROLE_SUPERADMIN = 8;

export const wakilni_user_roles = [
  {
    id: 1,
    label: 'Admin',
  },
  {
    id: 4,
    label: 'Operator',
  },
  {
    id: 5,
    label: 'Accountant',
  },
  {
    id: 6,
    label: 'Tracker',
  },
  {
    id: 7,
    label: 'External Viewer'
  },
];

export const partner_user_roles = [
  {
    id: 14,
    label: 'Staff',
  },
];

export const warehouse_user_roles = [
  {
    id: 9,
    label: 'Admin',
  },
  {
    id: 10,
    label: 'Warehouse Manager',
  },
  {
    id: 11,
    label: 'Stock Controller',
  },
  {
    id: 12,
    label: 'Fulfillment Officer',
  },
];

export const REVIEWS = [
  { id: 1, label: 'Great' },
  { id: 2, label: 'Good' },
  { id: 3, label: 'Ok' },
  { id: 4, label: 'Bad' },
];

export const SHOP_REVIEWS = [
  { id: 1, label: '1' },
  { id: 2, label: '2' },
  { id: 3, label: '3' },
  { id: 4, label: '4' },
  { id: 5, label: '5' },

];
export const ORDER_CRITICALNESS = [
  { id: 1, label: 'Critical' },
  { id: 2, label: 'Double Critical' },
];
export const DEFAULT_COUNTRY = process.env.REACT_APP_COUNTRY == "JO" ? 101 : 115;
export const COUNTRY_LEBANON = 115;
export const COUNTRY_JORDAN = 101;
// ISO weekday (1=Mon .. 7=Sun) of the country weekend: Friday in Jordan, Sunday in Lebanon.
export const WEEKEND_ISO_DAY = process.env.REACT_APP_COUNTRY == "JO" ? 5 : 7;
export const ORDER_SOURCES = [
  {
    id: 1,
    label: "Portal"
  },
  {
    id: 2,
    label: "Mobile"
  },
  {
    id: 3,
    label: "Marketplace"
  },
  {
    id: 4,
    label: "API"
  },
  /* CASHBOX_V1_DEPRECATED
  {
    id: 5,
    label: "Cashbox"
  },
  CASHBOX_V1_DEPRECATED */
  {
    id: 6,
    label: "Cashbox"
  },
  {
    id: 7,
    label: "YellowStore"
  },
  {
    id: 8,
    label: "Sunduqz"
  },
  {
    id: 9,
    label: "Invoice"
  },
];

export const ORDER_SOURCE_CASHBOX = 5;
export const ORDER_SOURCE_CASHBOX_V2 = 6;
export const ORDER_SOURCE_MARKETPLACE = 3;
export const ORDER_SOURCE_INVOICE_V2 = 9;
export const ORDER_SOURCE_YELLOW_STORES = 7;

export const countries= ['LB','JO']

export const OFFICIALINVOICE = [
  { id: 1, label: 'Without Official Invoice' },
  { id: 2, label: 'With Official Invoice' },
  { id: 3, label: 'Paid Separately' },
  { id: 4, label: 'Deducted from next cashbox'}
];

// Cashbox frequencies, matching CashboxSettingV2::FREQUENCY_LABELS on the API.
// Listed the way the setup screen lists them — least frequent first — so the
// reports filter reads the same as CashboxSetupV2.
export const CASHBOX_FREQUENCIES = [
  { id: 9, label: 'Once every four weeks' },
  { id: 5, label: 'Once every two weeks' },
  { id: 2, label: 'Once a week' },
  { id: 3, label: 'Twice a week' },
  { id: 4, label: 'Three times a week' },
  { id: 1, label: 'Daily' },
];

// The two report filters that map to the official_invoice / separate_payment
// flags. Ids match CashboxReportService::INVOICE_MODEL_* / PAYMENT_MODEL_*.
export const CASHBOX_REPORT_INVOICE_MODELS = [
  { id: 1, label: 'Non-Invoiced' },
  { id: 2, label: 'Invoiced' },
];

export const CASHBOX_REPORT_PAYMENT_MODELS = [
  { id: 1, label: 'Separate' },
  { id: 2, label: 'Within Cashbox' },
];

// The reports the Cashboxes > Reports page can send.
//
// `columns` and `sheets` mirror the workbooks the API builds
// (CashboxSettingsReportExport / CustomerBalancesReportExport /
// CashboxApprovalRequestsReportExport) so the page can show the file's actual
// header row rather than describe it in prose. Keep them in step with those
// exports. A report too wide to preview whole names the headings worth showing
// in `previewColumns`.
//
// CASHBOX_REPORT_CURRENCY_TOKEN marks a heading that repeats once per currency
// present in the data; the page renders it as a highlighted placeholder.
export const CASHBOX_REPORT_CURRENCY_TOKEN = '{CUR}';

export const CASHBOX_REPORTS = [
  {
    id: 'settings',
    label: 'Cashbox Settings',
    sheets: ['Cashbox Settings'],
    columns: [
      'Client Name',
      'Accounting Reference',
      'Client Type',
      'Cashbox Frequency',
      'Cashbox Days',
      'Office',
      'Official Invoice',
      'Payment',
    ],
    note: 'One row per cashbox setup.',
  },
  {
    id: 'balances',
    label: 'Client Balances',
    sheets: ['Invoiced', 'Non-Invoiced'],
    columns: [
      'Client Name',
      'Accounting Reference',
      'Payment',
      '{CUR} Balance',
      '{CUR} RTD Amount',
      'Open Invoices',
      '{CUR} Unpaid Invoices',
    ],
    note:
      'One row per client, on the sheet matching their invoicing model. RTD Amount is the settlement of any ready-to-deliver cashbox.',
  },
  {
    id: 'approvals',
    label: 'Cashbox Approval Requests',
    sheets: ['Cashbox Approval Requests'],
    columns: [
      'Cashbox ID',
      'Cashbox Status',
      'Client',
      'Accounting Reference',
      'Scheduled Date',
      'Location',
      'Wakilni Branch',
      'Settlement',
      'Balance',
      'Invoice',
      'Notes',
      'Approver Name',
      'Approver Email',
      'Approval Status',
      'Approval Date',
      'Approval Comment',
      'Cashbox Order ID',
      'Cashbox Order Status',
    ],
    previewColumns: [
      'Cashbox ID',
      'Cashbox Status',
      'Client',
      'Scheduled Date',
      'Settlement',
      'Approver Name',
      'Approval Status',
      'Approval Date',
      'Approval Comment',
      'Cashbox Order ID',
    ],
    note:
      'One row per cashbox order of the cashboxes scheduled in the selected dates, with the client\'s answer on it.',
  },
];

export const MathOps = [
  { id: '=', label: 'Equal (=)' },
  { id: '>', label: 'Greater than (>)' },
  { id: '<', label: 'Less than (<)' },
  { id: '>=', label: 'Greater than or equal (>=)' },
  { id: '<=', label: 'Less than or equal (<=)' },
];

export const CASHBOX_PAYMENT_TYPE_ORDER = 1;
export const CASHBOX_PAYMENT_TYPE_BOB_FINANCE = 2;
export const CASHBOX_PAYMENT_TYPE_WALLET = 3;

export const CASHBOX_PAYMENT_TYPES = [
  { id: 1, label: "Order" },
  { id: 2, label: "BOB Finance" },
  { id: 3, label: "Wakilni Wallet" },
];

export const CLIENT_APPROVAL_STATUSES = [
  { id: 1, label: "Pending" },
  { id: 2, label: "Approved" },
  { id: 3, label: "Rejected" },
];

export const ORDER_COLLECTION_PAYMENT_TYPES = [
  { id: MONEY_CASH, label: "Cash" },
  { id: MONEY_CARD, label: "Card" },
];

export const ALLOWEDUSERS =
  process.env.REACT_APP_COUNTRY == "JO" ? [82] : [21989, 19156];
